export default {"buttonScrollToTopSkin2Container":"Xj0jN","btnBox":"fhS5r","scrollBtnBox":"Q4-qu"};